<template>
  <v-card flat class="settings-card">
    <v-container>
      <graph-and-grid
        Title="Feedback"
        DisplayingText="feedback"
        :Headers="headers"
        ApiPath="/biz-review-feedbacks"
        :SearchLocal="true"
        :IsReport="false"
      >
      </graph-and-grid>
    </v-container>
  </v-card>
</template>

<script>
import GraphAndGrid from "../../reports/shared/GraphAndGrid.vue";

export default {
  name: "ReviewsFeedback",
  components: {
    GraphAndGrid
  },
  data() {
    return {
      headers: [
        {
          text: "Message",
          value: "message",
          width: "70%"
        },
        {
          text: "Customer",
          value: "customerId",
          width: "15%"
        },
        {
          text: "Date",
          value: "createdAt",
          width: "15%"
        }
      ]
    };
  },
  created() {
    this.$store.dispatch("entities/bizReviewFeedbacks/hydrate", 0);
  },
  computed: {
    reviewFeedbacks() {
      const feedbacks = this.$store.getters[
        "entities/bizReviewFeedbacks/query"
      ]()
        .orderBy("createdAt", "desc")
        .get();
      return feedbacks.map((val, i) => {
        const tempCust = this.$store.getters["entities/customerLookups/find"](
          val.customerId
        );
        return {
          id: val.id,
          date: val.createdAt
            ? new Date(val.createdAt).toLocaleDateString("en-US")
            : "",
          message: val.message,
          customerId: val.customerId,
          customerName:
            tempCust && tempCust.name ? tempCust.name : "Anonymous"
        };
      });
    },
    hasFeedback() {
      if (this.reviewFeedbacks && this.reviewFeedbacks.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {},
  methods: {
    async clickCustomer(id) {
      if (id) {
        await this.$store.dispatch("entities/customers/clickCustomer", {
          customerId: id
        });
        this.$router.push({ path: "/customers/" });
      }
    }
  }
};
</script>

<style scoped lang="stylus"></style>
